import React from "react";

const BS5_GridXSmall = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridXSmall Component</h2>
      <p>This is the BS5_GridXSmall component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridXSmall;
